import React, { useState, Component, useRef } from 'react'

import { connect } from "react-redux"

import '../css/menu.css'

import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"
import * as systemParameterActionCreators from "../actionCreators/systemParameter"
import * as lookupCodeActionCreators from "../actionCreators/lookupCode"

import { withRouter } from 'react-router' // need to use withRouter higher order component to access the routing history since the menu isn't a component contained in the current route
import { Link } from 'react-router-dom' //When clicking a <Link>, the URL will be updated and the rendered content will change without reloading the page.

import { Sidebar } from 'primereact/sidebar'

import { ROLE_ADMIN, ROLE_CANDIDATE,ROLE_GOVERNMENT } from '../js/const'

class Menu extends Component {
  componentDidMount() {
    this.props.setLoading(true)
      .then(() => this.props.getFaqUrl(true))
      .then(() => this.props.setLoading(false))
      .catch(error => {
        this.props.handleError(error)
          .then(() => this.props.setLoading(false))
      })
  }

  performLogout = (e) => {
    e.preventDefault()
    this.props.setLoading(true)
      .then(() => this.props.performLogout())
      .then(() => {
        this.props.history.push('/')
        this.props.setLoading(false)
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))

  }

  render() {
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)
    let isCandidate = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_CANDIDATE)
    let isGovernment = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_GOVERNMENT);

    let menuItemsMetadata = [
      { path: '/', displayText: 'Home', isVisible: this.props.auth.isAuthenticated === false || isCandidate === true },
      { path: '/', displayText: 'List of Candidates', isVisible: this.props.auth.isAuthenticated === true && isCandidate === false },
      { path: '/candidate/', displayText: 'Create Candidate', isVisible: this.props.auth.isAuthenticated === true && isCandidate === false },
      { path: `/candidate/${this.props.auth.candidateId}`, displayText: 'My Profile', isVisible: this.props.auth.isAuthenticated === true && this.props.auth.candidateId },
      { path: `/change-password/${this.props.auth.candidateId}`, displayText: 'Change Password', isVisible: this.props.auth.isAuthenticated === true && this.props.auth.candidateId },
      { path: '/candidate/', displayText: 'Register', isVisible: this.props.auth.isAuthenticated === false },
      { path: '/login', displayText: 'Login', isVisible: this.props.auth.isAuthenticated === false },
      { path: '/system-parameter', displayText: 'Maintain System Parameters', isVisible: this.props.auth.isAuthenticated === true && isAdmin === true },
      { path: '/lookup-code', displayText: 'Maintain Lookup Codes', isVisible: this.props.auth.isAuthenticated === true && isAdmin === true },
      { path: '/audit-log', displayText: 'View Audit Logs', isVisible: this.props.auth.isAuthenticated === true && isAdmin === true },
      { path: '/user', displayText: 'Maintain Users', isVisible: this.props.auth.isAuthenticated === true && isAdmin === true },
      { path: '/faq', displayText: 'FAQ', isVisible:true},
      { path: '/contactus', displayText: 'Contact Us', isVisible: this.props.auth.isAuthenticated === false || isCandidate === true || isGovernment === true } ,
      { displayText: 'Logout', isVisible: this.props.auth.isAuthenticated === true && isAdmin === false, onClick: this.performLogout }
    ]
    let menuItems = menuItemsMetadata.map(menuItemMetadata => {
      let isActive = menuItemMetadata.path === this.props.location.pathname
      
      return (
     
        <React.Fragment key={menuItemMetadata.displayText}>
           
          {menuItemMetadata.isVisible &&
            <li   className={isActive ? 'menu-item active' : 'menu-item'}>
              {menuItemMetadata.path && <Link to={menuItemMetadata.path}>
                <div>{menuItemMetadata.displayText}</div>
              </Link>}
              {menuItemMetadata.onClick && <a  href="#" onClick={menuItemMetadata.onClick}>{menuItemMetadata.displayText}</a>}
            </li>}
   
        </React.Fragment>
      )
    })
  
    return (
      
      <Sidebar className="menu p-col-12 p-md-2"  visible={this.props.app.isMenuOpen} dismissable={false} showCloseIcon={false}
        onHide={() => this.props.toggleMenu()} >
          <ul>
        {menuItems}
        </ul>
       {/*<div className="menu-item">
          <a href={this.props.systemParameter.faqUrl} target={'_blank'}>FAQ</a>
        </div>*/}
      </Sidebar> 
    );
  }
}

const mapStateToProps = ({ app, auth, systemParameter, lookupCode }) => {
  return { app, auth, systemParameter, lookupCode }
}

// this is how to combine actions available
const actionCreators = {
  ...authActionCreators,
  ...appActionCreators,
  ...systemParameterActionCreators,
  ...lookupCodeActionCreators
}

export default withRouter(connect(mapStateToProps, actionCreators)(Menu))



// WEBPACK FOOTER //
// ./src/container/Menu.js